import { AccessPointProcessingResult } from "../models";

export type ImportResultsActions =
  { type: ImportResultsAction.LoadResults, versionId: number } |
  { type: ImportResultsAction.LoadResultsSuccess, result: AccessPointProcessingResult[] } |
  { type: ImportResultsAction.LoadResultsFailure, error: string };

export enum ImportResultsAction {
  LoadResults = "LOAD_RESULTS",
  LoadResultsSuccess = "LOAD_RESULTS_SUCCESS",
  LoadResultsFailure = "LOAD_RESULTS_FAILURE",
}
